import React from 'react'

function WeatherApplication() {
  return (
    <div>
      
    </div>
  )
}

export default WeatherApplication
